import styled from "styled-components";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import { barberSHopDatas } from "../barberShopDatas";
import { Divider, device } from "../styled";
import { useMediaQuery } from "react-responsive";

const Container = styled.div`
  color: #fff;
  ${Divider} {
    margin: 40px auto;
  }
`;
const ConnectionContainer = styled.div`
  display: flex;
  justify-content: center;
`;
const BarberShopContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media ${device.desktop} {
    width: 75%;
    justify-content: space-around;
    flex-direction: row;
    gap: 30px;
  }
`;
const MapContainer = styled.div`
  width: 40%;
  display: flex;
`;
const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media ${device.desktop} {
    width: 40%;
  }
`;
const BarberContainer = styled.div``;
const CityName = styled.h2`
  font-size: 2em;
  text-transform: uppercase;
  color: #008080;
  font-weight: bold;
  margin-top: 0;
`;
const Address = styled.p``;
const OpeningHours = styled.p``;
const Email = styled.p``;
const Phone = styled.p``;
const BarberPicture = styled.img`
  width: 70px;
`;
const BarberName = styled.p``;
const MapImage = styled.img`
  width: 90vw;
  border: 4px #fff solid;
  border-radius: 10px;
  @media ${device.desktop} {
    width: 100%;
  }
`;

const BarberTitle = styled.h2`
  text-align: center;
`;
const Barbers = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 90vw;

  @media ${device.desktop} {
    width: 80vw;
    gap: 20px;
    width: auto;
  }
`;
const Barber = styled.div`
  display: flex;
  width: 100px;
  text-align: center;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;

const LineDivider = styled.div`
  background-color: #008080;
  width: 2px;
  height: 100%;
`;

const DividerContainer = styled.div`
  display: flex;
`;

const Connection = () => {
  const { csorna, gyor, moson } = barberSHopDatas;

  const isDesktop = useMediaQuery({
    query: "(min-width: 1024px)",
  });

  return (
    <Container>
      <PageHeader title="Kapcsolat" />
      <ConnectionContainer>
        <BarberShopContainer>
          {isDesktop && (
            <MapContainer>
              <MapImage src={gyor.mapImage} />
            </MapContainer>
          )}
          <LineDivider />
          <InformationContainer>
            <CityName>Győr</CityName>
            <Address>Móricz Zsigmond rkp. 8</Address>
            <OpeningHours>H-P: 09:00 - 19:00</OpeningHours>
            <OpeningHours>Sz: 09:00 - 12:00</OpeningHours>
            <Email>{gyor.email}</Email>
            <Phone>{gyor.phone}</Phone>
            <BarberContainer>
              <BarberTitle>Kik dolgoznak a szalonban?</BarberTitle>
              <Barbers>
                {gyor.barbers.map((barber) => (
                  <Barber>
                    <BarberPicture src={barber.imgPath} />
                    <BarberName>{barber.name}</BarberName>
                  </Barber>
                ))}
              </Barbers>
            </BarberContainer>
          </InformationContainer>
          {!isDesktop && (
            <MapContainer>
              <MapImage src={gyor.mapImage} />
            </MapContainer>
          )}
        </BarberShopContainer>
      </ConnectionContainer>

      <DividerContainer>
        <Divider />
      </DividerContainer>

      <ConnectionContainer>
        <BarberShopContainer>
          <InformationContainer>
            <CityName>Mosonmagyaróvár</CityName>
            <Address>Magyar utca 4</Address>
            <OpeningHours>H-P: 10:00 - 20:00</OpeningHours>
            <OpeningHours>Sz-V: Zárva</OpeningHours>
            <Email>{moson.email}</Email>
            <Phone>{moson.phone}</Phone>
            <OpeningHours></OpeningHours>
            <BarberContainer>
              <BarberTitle>Kik dolgoznak a szalonban?</BarberTitle>
              <Barbers>
                {moson.barbers.map((barber) => (
                  <Barber>
                    <BarberPicture src={barber.imgPath} />
                    <BarberName>{barber.name}</BarberName>
                  </Barber>
                ))}
              </Barbers>
            </BarberContainer>
          </InformationContainer>
          <LineDivider />
          <MapContainer>
            <MapImage src={moson.mapImage} />
          </MapContainer>
        </BarberShopContainer>
      </ConnectionContainer>

      <DividerContainer>
        <Divider />
      </DividerContainer>

      <ConnectionContainer>
        <BarberShopContainer>
          {isDesktop && (
            <MapContainer>
              <MapImage src={csorna.mapImage} />
            </MapContainer>
          )}
          <LineDivider />
          <InformationContainer>
            <CityName>Csorna</CityName>
            <Address>Soproni út 63</Address>
            <OpeningHours>H, Sz, P: 09:00 - 20:00</OpeningHours>
            <OpeningHours>K: 08:00 - 20:00"</OpeningHours>
            <OpeningHours>Cs: 10:00 - 20:00</OpeningHours>
            <OpeningHours>Sz-V: Zárva</OpeningHours>
            <Email>{csorna.email}</Email>
            <Phone>{csorna.phone}</Phone>
            <BarberContainer>
              <BarberTitle>Kik dolgoznak a szalonban?</BarberTitle>
              <Barbers>
                {csorna.barbers.map((barber) => (
                  <Barber>
                    <BarberPicture src={barber.imgPath} />
                    <BarberName>{barber.name}</BarberName>
                  </Barber>
                ))}
              </Barbers>
            </BarberContainer>
          </InformationContainer>
          {!isDesktop && (
            <MapContainer>
              <MapImage src={gyor.mapImage} />
            </MapContainer>
          )}
        </BarberShopContainer>
      </ConnectionContainer>

      <Footer />
    </Container>
  );
};

export default Connection;
